export default {
    "Couldn't find a user associated to the id 0": {
        message: 'Cannot delete this logo as it was uploaded by another user.',
        notificationLevel: 'warning',
    },
};
